var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "message-list" }, [
      _c(
        "div",
        { staticClass: "message-list--items" },
        [
          _c("ListItem", {
            attrs: { "is-recipient": "" },
            scopedSlots: _vm._u([
              {
                key: "text",
                fn: function() {
                  return [
                    _c("b", [
                      _vm._v(
                        "Die Kandidaten müssen bei skilldoo keinen Lebenslauf hinterlegen!"
                      )
                    ])
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("ListItem", {
            attrs: { "is-recipient": "" },
            scopedSlots: _vm._u([
              {
                key: "text",
                fn: function() {
                  return [
                    _vm._v(
                      "\n\t\t\t\t\tWenn du trotzdem einen anforderst, kann es sein, dass du den Kandidaten verlierst."
                    ),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t\tMöchtest du das Risiko eingehen?\n\t\t\t\t"
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex align-items-center mt-5" }, [
      _c(
        "div",
        { staticClass: "flex-grow-1 mr-2" },
        [
          !_vm.loading
            ? _c("Button", {
                attrs: { text: "Abbrechen", icon: "close" },
                on: {
                  click: function($event) {
                    return _vm.$emit("cancel")
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("Button", {
            attrs: {
              text: "Lebenslauf trotzdem anfordern",
              icon: "checkmark",
              secondary: "",
              disabled: _vm.loading,
              loading: _vm.loading
            },
            on: {
              click: function($event) {
                return _vm.$emit("request")
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }